import React from "react";
import "./App.css";
import "react-circular-progressbar/dist/styles.css";
import AppRoutes from "./ui/layout/AppRoutes";
const App = () => {
    return (React.createElement("div", { style: { width: "100%", backgroundColor: "#FAFDFF", height: "100%" } },
        React.createElement(AppRoutes, null)));
};
export default App;
